import { render, staticRenderFns } from "./settleRecord.vue?vue&type=template&id=72599715&scoped=true"
import script from "./settleRecord.vue?vue&type=script&lang=js"
export * from "./settleRecord.vue?vue&type=script&lang=js"
import style0 from "./settleRecord.vue?vue&type=style&index=0&id=72599715&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72599715",
  null
  
)

export default component.exports